import { render, staticRenderFns } from "./GzhCodeView.vue?vue&type=template&id=5075e948&scoped=true"
import script from "./GzhCodeView.vue?vue&type=script&lang=js"
export * from "./GzhCodeView.vue?vue&type=script&lang=js"
import style0 from "./GzhCodeView.vue?vue&type=style&index=0&id=5075e948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075e948",
  null
  
)

export default component.exports